var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 17.5C1.70833 17.5 1.31597 17.3368 0.989583 17.0104C0.663194 16.684 0.5 16.2917 0.5 15.8333V4.16668C0.5 3.70834 0.663194 3.31598 0.989583 2.98959C1.31597 2.6632 1.70833 2.50001 2.16667 2.50001H5.66667C5.84722 2.00001 6.14931 1.59723 6.57292 1.29168C6.99653 0.986121 7.47222 0.833344 8 0.833344C8.52778 0.833344 9.00347 0.986121 9.42708 1.29168C9.85069 1.59723 10.1528 2.00001 10.3333 2.50001H13.8333C14.2917 2.50001 14.684 2.6632 15.0104 2.98959C15.3368 3.31598 15.5 3.70834 15.5 4.16668V15.8333C15.5 16.2917 15.3368 16.684 15.0104 17.0104C14.684 17.3368 14.2917 17.5 13.8333 17.5H2.16667ZM3.83333 14.1667H9.66667V12.5H3.83333V14.1667ZM3.83333 10.8333H12.1667V9.16668H3.83333V10.8333ZM3.83333 7.50001H12.1667V5.83334H3.83333V7.50001ZM8 3.54168C8.18056 3.54168 8.32986 3.48265 8.44792 3.36459C8.56597 3.24654 8.625 3.09723 8.625 2.91668C8.625 2.73612 8.56597 2.58682 8.44792 2.46876C8.32986 2.3507 8.18056 2.29168 8 2.29168C7.81944 2.29168 7.67014 2.3507 7.55208 2.46876C7.43403 2.58682 7.375 2.73612 7.375 2.91668C7.375 3.09723 7.43403 3.24654 7.55208 3.36459C7.67014 3.48265 7.81944 3.54168 8 3.54168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.b923bf34d4c4e1097b3752c2e948d0c0.svg";
export { ForwardRef as ReactComponent };